import firebase from 'firebase';

import * as collections from '../collectionTypes';

const db = firebase.firestore();
const collection = db.collection(collections.SUBSCRIPTIONS);

function getSubscription(uid, postId) {
  return collection
    .where('uid', '==', uid)
    .where('postId', '==', postId)
    .limit(1)
    .get()
    .then(snapshot => (snapshot.empty ? null :
      { id: snapshot.docs[0].id, ...snapshot.docs[0].data() }));
}

function updateOrCreateSubscriptionWithStatus(uid, postId, status) {
  return getSubscription(uid, postId)
    .then((subscription) => {
      if (subscription) {
        return collection.doc(subscription.id).update({ status });
      }

      return collection.add({ uid, postId, status });
    });
}

export function isSubscribed(uid, postId) {
  return collection
    .where('uid', '==', uid)
    .where('postId', '==', postId)
    .limit(1)
    .get()
    .then(snapshot => Boolean(snapshot.empty || snapshot.docs[0].data().status));
}


export function unsubscribe(uid, postId) {
  return updateOrCreateSubscriptionWithStatus(uid, postId, false);
}

export function subscribe(uid, postId) {
  return updateOrCreateSubscriptionWithStatus(uid, postId, true);
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/subscriptions.js